import { https } from "./api";

export default class {
  constructor() {
    this.instance = https("/courses");
  }

  fetchCourses = () => {
    return this.instance({
      method: "GET"
    });
  };

  getCritical = (date, courseId, codFilial) => {
    return this.instance({
      method: "GET",
      url: `${date}/${courseId}/${codFilial}/critical`
    })
  }

  getOffers = (courseId, classificationId) => {
    return this.instance({
      method: "GET",
      url: `${courseId}/${classificationId}/offer`
    });
  };

  getOffersREM = (qualificationId, ra, data) => {
    return this.instance({
      method: "GET",
      url: `rem/${qualificationId}/${ra}/${data}/offer`
    });
  };

  getClasses = (
    shift,
    courseId,
    qualificationId,
    campusId,
    codFilial,
    codDisc1,
    codDisc2,
    codDisc3,
    classificationId
  ) => {
    return this.instance({
      method: "GET",
      url: `${shift}/${courseId}/${qualificationId}/${campusId}/${codFilial}/${codDisc1}/${codDisc2}/${codDisc3}/${classificationId}/classes`
      //timeout: 5000,
    });
  };

  getClassesRem = (
    courseId,
    qualificationId,
    campusId,
    codDisc1,
    codDisc2,
    codDisc3,
    classificationId,
    initialDate,
    ra
  ) => {
    return this.instance({
      method: "GET",
      url: `rem/${courseId}/${qualificationId}/${campusId}/${codDisc1}/${codDisc2}/${codDisc3}/${classificationId}/${initialDate}/${ra}/classes`
    });
  };

  getElectives = (
    courseId,
    qualificationId,
    classificationId,
    campusId = 0
  ) => {
    return this.instance({
      method: "GET",
      url: `${courseId}/${qualificationId}/${classificationId}/${campusId}/electives`
    });
  };
  getEletivesRem = (
    courseId,
    qualificationId,
    classificationId,
    initialDate
  ) => {
    return this.instance({
      method: "GET",
      url: `rem/${courseId}/${qualificationId}/${classificationId}/${initialDate}/electives`
    });
  };

  getIntroductories = (
    courseId,
    qualificationId,
    inicialDate,
    classificationId,
    classDataId,
    campusId = 0
  ) => {
    return this.instance({
      method: "GET",
      url: `${courseId}/${qualificationId}/${inicialDate}/${classificationId}/${classDataId}/${campusId}/introductories`
    });
  };

  getSubjects = (
    classSubjectId,
    courseId,
    classificationId,
    introductoryId,
    qualificationId,
    elective1Id,
    elective2Id,
    elective3Id,
    campusId = 0
  ) => {
    return this.instance({
      method: "GET",
      url: `${classSubjectId}/${courseId}/${classificationId}/${introductoryId}/${qualificationId}/${elective1Id}/${elective2Id}/${elective3Id}/${campusId}/subjects`
    });
  };

  getSubjectsRem = (
    idTurmaDisc,
    codCurso,
    classificationId,
    idClassDiscIntro,
    idHabilitacaoFilial,
    codDisc1,
    codDisc2,
    codDisc3,
    ra,
    initialDate
  ) => {
    return this.instance({
      method: "GET",
      url: `rem/${idTurmaDisc}/${codCurso}/${classificationId}/${idClassDiscIntro}/${idHabilitacaoFilial}/${codDisc1}/${codDisc2}/${codDisc3}/${ra}/${initialDate}/subjects`
    });
  };

  getValRem01 = (idClassificacao, codCurso, ra) => {
    return this.instance({
      method: 'GET',
      url: `/valrem01/${idClassificacao}/${codCurso}/${ra}`
    });
  };

  getValRem02 = (idClassificacao, codCurso, idHabilitacaoFilial, codPolo, ra, dataRematricula, nomeTurma) => {
    return this.instance({
      method: 'GET',
      url: `/valrem02/${idClassificacao}/${codCurso}/${idHabilitacaoFilial}/${codPolo}/${ra}/${dataRematricula}/${nomeTurma}`
    });
  };

  getValMat01 = (idClassificacao, codCurso) => {
    return this.instance({
      method: 'GET',
      url: `/valmat01/${idClassificacao}/${codCurso}`
    });
  };

  getValMat02 = (idClassificacao, codCurso, idHabilitacaoFilial, codPolo, nomeTurma) => {
    return this.instance({
      method: 'GET',
      url: `/valmat02/${idClassificacao}/${codCurso}/${idHabilitacaoFilial}/${codPolo}/${nomeTurma}`
    });
  };
}
